import * as schema from "./schema";
import * as products from "./products";
import * as media from "./media";
import * as ui from "./ui";
import * as translation from "./translation";
import * as field from "./field";
import * as group from "./group";
import * as tab from "./tab";
import * as tag from "./tag";
import * as collection from "./collection";
import { RootState } from ".";
import { Category } from "./ui/StatusMessage";

export const getProducts = (state: RootState) => products.getProducts(state.products);

export const getProductById = (state: RootState, id: string) => products.getProductById(state.products, id);

export const getTemplates = (state: RootState) => schema.getTemplates(state.schema);

export const getTemplateById = (state: RootState, id: string) => schema.getTemplateById(state.schema, id);

export const getTemplatesByType = (state: RootState, type: string) => schema.getTemplatesByType(state.schema, type);

export const getStatusMessages = (state: RootState, category?: Category) => ui.getStatusMessages(state.ui, category);

export const getFolderContent = (state: RootState, parentId?: string) => media.getFolderContent(state.media, parentId);

export const getMediaByType = (state: RootState, type: string) => media.getMediaByType(state.media, type);

export const getMedia = (state: RootState, id: string) => media.getMedia(state.media, id);

export const getMultipleMedia = (state: RootState, ids: string[]) => media.getMultipleMedia(state.media, ids);

export const getAllMediaItems = (state: RootState) => media.getAllMediaItems(state.media);

export const getLanguages = (state: RootState) => translation.getLanguages(state.translation);

export const getAllAvailableLanguages = (state: RootState) => translation.getAllAvailableLanguages(state.translation);

export const getTranslations = (state: RootState, language: string) => translation.getTranslations(state.translation, language);

export const getAllFieldTranslations = (state: RootState, language: string) => translation.getAllFieldTranslations(state.translation, language);

export const getFieldValues = (state: RootState, fieldName: string) => field.getFieldValues(state.field, fieldName);

export const getFieldTranslations = (state: RootState, fieldName: string) => 
    field.getTranslations(state.field, fieldName);

export const getFields = (state: RootState) => field.getFields(state.field);

export const getGroups = (state: RootState) => group.getGroups(state.group);

export const getTabs = (state: RootState) => tab.getTabs(state.tab);

export const getTags = (state: RootState) => tag.getTags(state.tag);

export const getProductPageCount = (state: RootState) => products.getPages(state.products);

export const getCollections = (state: RootState) => collection.getCollections(state.collection);

export const getCollection = (state: RootState, collectionId: string) => collection.getCollection(state.collection, collectionId);


// WEBPACK FOOTER //
// ./src/state/action.ts